/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { AutocompleteModule } from '@ng-falcon/controls/autocomplete/autocomplete.module';
import { ShareMenuComponent } from '../shared/share-menu/share-menu.component';
import { CommunityFeedModule } from '../common/community/feed/community-feed.module';
import { ProjectsPageComponent } from './projects-page.component';
import { ProjectCardComponent } from './card/project-card.component';
import { ProjectPageComponent } from './project/project-page.component';
import { ProjectListPageComponent } from './tag-list/project-list-page.component';
import { FilterSelectComponent } from './filter-select/filter-select.component';

// Not standalone, for the same reason as CommunityFeedModule: it imports CommunityFeedModule, which pulls in
// UpgradeModule.
@NgModule({
  imports: [
    CommonModule,
    UIRouterModule,
    CommunityFeedModule,
    ShareMenuComponent,
    AutocompleteModule,
  ],
  declarations: [
    ProjectsPageComponent,
    ProjectCardComponent,
    ProjectPageComponent,
    ProjectListPageComponent,
    FilterSelectComponent,
  ],
  exports: [ProjectsPageComponent, ProjectPageComponent, ProjectListPageComponent],
})
class ProjectsPageModule {}

export { ProjectsPageModule };
